<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content modal-sm">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p> {{obj.xbody}} </p>
                <BuscarDocente :model="docente" />
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'La asignacion de codigo se realizo satisfactoriamente.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Asignar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import gql from 'graphql-tag'
import BuscarDocente from '@/components/ABuscarDocentes.vue'
import Alertas from '@/components/AAlertas.vue'

    export default {
        props: {
            obj:{ // {xid:Number,xidpro:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
              docente:{},
                activo: true,
                codigo: null,
            }
        },
        watch:{
            'obj.xid': function(){ 
                if( this.obj.xid == null ) return;
                this.$refs.alertar.reset(); 
                this.activo = true;
                // window.console.log( "MODALLLLLLLLLLLLLLLLll" ); 
            },
            'obj':function(){ 
                this.$refs.alertar.reset();
                this.activo = true;
            }
        },
        components:{Alertas,BuscarDocente},
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            }, 
            submit(){
                if( !this.docente.iddocente ){
                  this.$refs.alertar.invalido( "Debe seleccionar un docente para asignar." );
                  return;
                }
                var vue = this;
                var doce = this.docente.iddocente;
                var tag = gql`mutation{asignarDocente(input:{idmodulo:${this.obj.xid},idprograma:${this.obj.xidpro},iddocente:${doce}}){ok errors{message}}}`;
                vue.$refs.alertar.cargando();
                vue.activo = false;
                window.console.log( tag )

                this.$apollo.mutate({
                    mutation: tag,
                }).then((data) => {
                    window.console.log(data.data.asignarDocente);
                    if( data.data.asignarDocente.ok ) vue.$refs.alertar.success("Docente asignado");
                    else{
                      vue.$refs.alertar.success("NO SE HA PODIDO ASIGNAR EL DOCENTE");
                    }

                    this.$emit('exito');
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
    
    }
</script>